import get from "lodash/get";
import { store } from "../../store";
import { StoreState } from "../../reducers";
import {
  getCampaignId,
  getMerchantId,
  getScreenName,
  getWidgetConfig,
  getWidgetConfigId,
  getWidgetData,
} from "../../reducers/methods";
import { createEventPayload } from "./createEventPayload";
import { MerchantRemoteResponse, PostRemoteRequest } from "../remoteAction";
import { sessionId } from "../../config";

export type WidgetEventTrackActionSuccess = MerchantRemoteResponse<
  "WIDGET_EVENT_TRACK_SUCCESS",
  any
>;
export type WidgetEventTrackActionFailure = MerchantRemoteResponse<
  "WIDGET_EVENT_TRACK_FAILURE",
  any
>;
export type WidgetEventTrackActionRequest = MerchantRemoteResponse<
  "WIDGET_EVENT_TRACK_REQUEST",
  any
>;

export interface WidgetEventTrackAction extends PostRemoteRequest {
  types: {
    request: "WIDGET_EVENT_TRACK_REQUEST";
    success: "WIDGET_EVENT_TRACK_SUCCESS";
    failure: "WIDGET_EVENT_TRACK_FAILURE";
  };
}

export interface WidgetEventTrackParams {
  type: string;
  // tslint:disable-next-line:no-any
  [prop: string]: any;
}

// tslint:disable-next-line: cyclomatic-complexity
export const widgetEventTrack = ({
  type,
  ...payload
}: WidgetEventTrackParams): WidgetEventTrackAction => {
  const state = store.getState() as StoreState;
  const screenName = get(
    getWidgetConfig(state)[getScreenName(state)],
    "label",
    "N/A"
  );
  const customerEmail = get(getWidgetData(state), "customer.email");
  const basePayload = {
    customerEmail: customerEmail || "",
    merchantId: payload.merchantId || getMerchantId(state),
    campaignId: payload.campaignId || getCampaignId(state),
    screenId: getScreenName(state),
    screenName,
    widgetId: payload.widgetConfigId || getWidgetConfigId(state),
    widgetConfigId: payload.widgetConfigId || getWidgetConfigId(state),
    type,
  };

  return {
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      request: "WIDGET_EVENT_TRACK_REQUEST",
      success: "WIDGET_EVENT_TRACK_SUCCESS",
      failure: "WIDGET_EVENT_TRACK_FAILURE",
    },
    data: {
      merchantId: basePayload.merchantId,
      payload: createEventPayload({
        event: {
          sessionId,
          ...basePayload,
          ...payload,
        },
      }),
      type,
    },
    fullPayload: payload,
    url: `/track/`,
    method: "POST",
    https: true,
  };
};
